import React from "react";

const MenuItemList = ({ items = [], onDelete, onEditItem }) => {
  // Aseguramos que items siempre sea un array válido
  const safeItems = Array.isArray(items)
    ? items.filter(item => item && item.id)
    : [];

  return (
    <div className="bg-[#F9EFD7] p-4 rounded-lg shadow">
      <h3 className="text-lg font-semibold text-[#3F1907] mb-3">Menú</h3>

      {safeItems.length === 0 ? (
        <p className="text-[#3F1907]">No hay productos en el menú</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-[#58735A]">
            <thead className="bg-[#58735A]">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Producto
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Precio con IVA
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Precio sin IVA
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Acciones
                </th>
              </tr>
            </thead>

            <tbody className="bg-[#F9EFD7] divide-y divide-[#58735A]">
              {safeItems.map((item) => {
                const price =
                  typeof item.price === "number" ? item.price : 0;

                const priceWithoutVAT =
                  typeof item.priceWithoutVAT === "number"
                    ? item.priceWithoutVAT
                    : price;

                return (
                  <tr key={item.id}>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">
                      {item.name || "Sin nombre"}
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">
                      ${price.toFixed(2)}
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907]">
                      ${priceWithoutVAT.toFixed(2)}
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap text-sm text-[#3F1907] space-x-2">
                      <button
                        onClick={() => onEditItem && onEditItem(item)}
                        className="text-blue-500 hover:text-blue-700 transition duration-200"
                      >
                        Editar
                      </button>

                      <button
                        onClick={() => onDelete && onDelete(item.id)}
                        className="text-red-500 hover:text-red-700 transition duration-200"
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MenuItemList;
